// lists all the valid classes used by the dynamic collection items
// all other classes will be stripped out
module.exports = {
    CUSTOM_ATTR_NAME: 'collection-item-classes',
    FLEX_CLASS_GROUPS: [
        'margin',
        'padding',
        'width',
    ],
};
